module.exports = __webpack_public_path__ + "42545c3f051e9e34488e14033664bc9b.MP3";